import { Column } from "react-table";
import { UtilFunctions } from "./UtilFunctions";

export const TABLE_COLUMNS_USERS = [
  {
    Header: "ID",
    accessor: "id",
    maxWidth: 80,
  },
  {
    Header: "Display Name",
    accessor: "displayName",
    // maxWidth: 100,
  },
  {
    Header: "Email",
    accessor: "email",
    // maxWidth: 100,
  },
  {
    Header: "Groups",
    accessor: "groups",
    // maxWidth: 100,
  },
];

export const TABLE_COLUMNS_GROUPS = [
  {
    Header: "ID",
    accessor: "id",
    maxWidth: 80,
  },
  {
    Header: "Name",
    accessor: "name",
  },
];

export const TABLE_COLUMNS_REPORTS: Column[] = [
  {
    Header: "ID",
    accessor: "id",
    maxWidth: 80,
  },
  {
    Header: "Car Wash Name",
    accessor: "carWashName",
    // maxWidth: 250,
  },
  {
    Header: "Date Created",
    accessor: "dateTimeCreated",
    // maxWidth: 200,
    sortType: "datetime",
    Cell: (props: any) => {
      return <div>{UtilFunctions.formatDate(props.value)}</div>;
    },
  },
  {
    Header: "County",
    accessor: "county",
    // maxWidth: 200,
  },
  {
    Header: "Police Area",
    accessor: "policeArea",
    // maxWidth: 200,
  },
  {
    Header: "Local Authority",
    accessor: "localAuth",
    // maxWidth: 200,
  },
  {
    Header: "MSH",
    accessor: "sentMSH",
    maxWidth: 80,
  },
  {
    Header: "Score",
    accessor: "score",
    maxWidth: 80,
  },
];
